// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-address-table {
  margin-bottom: 20px;
}

.address-section {
  margin-bottom: 20px;
}

.address-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.address-container {
  margin-top: 15px;
}

/* Entry Card Styling - Match other tables */
.entry-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 8px;
  align-items: flex-end;
}

.address-row:last-child {
  margin-bottom: 0;
}

/* Field Group Styling */

.field-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
}

/* Field size classes */
.field-small {
  min-width: 120px;
}

.field-medium {
  min-width: 160px;
}

.field-large {
  min-width: 200px;
}

.field-group label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 4px;
  line-height: 1.3;
  min-height: 18px;
  white-space: nowrap;
  overflow: visible;
}

.field-group input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fff;
  box-sizing: border-box;
  height: 36px;
}

.field-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.entry-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.entry-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.entry-number {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entry-badge {
  background: #007bff;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.entry-number h5 {
  margin: 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}

.entry-form {
  padding: 16px;
}

/* Form Rows - Compact layout like before */
.form-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  align-items: flex-end;
}

.form-row:last-child {
  margin-bottom: 0;
}

/* Row 1 - P.O. Box, Apt/Unit, Street #, Street Name */
.form-row-1 .field-group:nth-child(1) { /* P.O. Box */
  flex: 0 0 100px;
  max-width: 100px;
}

.form-row-1 .field-group:nth-child(2) { /* Apt/Unit */
  flex: 0 0 120px;
  max-width: 120px;
}

.form-row-1 .field-group:nth-child(3) { /* Street # */
  flex: 0 0 100px;
  max-width: 100px;
}

.form-row-1 .field-group:nth-child(4) { /* Street Name */
  flex: 1 1;
  min-width: 0;
}

/* Row 2 - City, Country, Province, Postal Code, District */
.form-row-2 .field-group {
  flex: 1 1;
  min-width: 0;
}

.form-row-2 .field-group:nth-child(4) { /* Postal Code */
  flex: 0 0 120px;
  max-width: 120px;
}

/* For residential address (no P.O. Box) - adjust selectors */
.residential-address-container .form-row-1 .field-group:nth-child(1) { /* Apt/Unit */
  flex: 0 0 120px;
  max-width: 120px;
}

.residential-address-container .form-row-1 .field-group:nth-child(2) { /* Street # */
  flex: 0 0 100px;
  max-width: 100px;
}

.residential-address-container .form-row-1 .field-group:nth-child(3) { /* Street Name */
  flex: 1 1;
  min-width: 0;
}

.residential-note {
  margin: 0 0 8px 0;
  color: #6c757d;
  font-style: italic;
}

.error-text {
  color: #dc3545;
  font-size: 13px;
  margin-top: 10px;
  display: block;
  padding: 10px 15px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    flex-wrap: wrap;
  }
  
  .form-row-1 .field-group,
  .form-row-2 .field-group {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 120px;
  }
  
  .same-address-options {
    flex-direction: column;
    gap: 8px;
  }
  
  .radio-option {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .form-row-1 .field-group,
  .form-row-2 .field-group {
    flex: 1 1 100%;
    min-width: 0;
  }
  
  .entry-form {
    padding: 12px;
  }
  
  .field-group input {
    padding: 8px 10px;
    font-size: 13px;
  }
  
  .field-group label {
    font-size: 12px;
    line-height: 1.3;
    min-height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicAddressTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD,wCAAwC,aAAa;EACnD,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC,aAAa;EACnD,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC,aAAa;EACnD,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC,gBAAgB;EACtD,SAAO;EACP,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,YAAY;AACd;;AAEA,wCAAwC,gBAAgB;EACtD,eAAe;EACf,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D,uEAAuE,aAAa;EAClF,eAAe;EACf,gBAAgB;AAClB;;AAEA,uEAAuE,aAAa;EAClF,eAAe;EACf,gBAAgB;AAClB;;AAEA,uEAAuE,gBAAgB;EACrF,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".dynamic-address-table {\n  margin-bottom: 20px;\n}\n\n.address-section {\n  margin-bottom: 20px;\n}\n\n.address-section h4 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.address-container {\n  margin-top: 15px;\n}\n\n/* Entry Card Styling - Match other tables */\n.entry-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 0;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  margin-bottom: 8px;\n  align-items: flex-end;\n}\n\n.address-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Field Group Styling */\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Field size classes */\n.field-small {\n  min-width: 120px;\n}\n\n.field-medium {\n  min-width: 160px;\n}\n\n.field-large {\n  min-width: 200px;\n}\n\n.field-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 4px;\n  line-height: 1.3;\n  min-height: 18px;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.field-group input {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 6px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: #fff;\n  box-sizing: border-box;\n  height: 36px;\n}\n\n.field-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.entry-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n.entry-header {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  padding: 12px 16px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.entry-number {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entry-badge {\n  background: #007bff;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.entry-number h5 {\n  margin: 0;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.entry-form {\n  padding: 16px;\n}\n\n/* Form Rows - Compact layout like before */\n.form-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  align-items: flex-end;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Row 1 - P.O. Box, Apt/Unit, Street #, Street Name */\n.form-row-1 .field-group:nth-child(1) { /* P.O. Box */\n  flex: 0 0 100px;\n  max-width: 100px;\n}\n\n.form-row-1 .field-group:nth-child(2) { /* Apt/Unit */\n  flex: 0 0 120px;\n  max-width: 120px;\n}\n\n.form-row-1 .field-group:nth-child(3) { /* Street # */\n  flex: 0 0 100px;\n  max-width: 100px;\n}\n\n.form-row-1 .field-group:nth-child(4) { /* Street Name */\n  flex: 1;\n  min-width: 0;\n}\n\n/* Row 2 - City, Country, Province, Postal Code, District */\n.form-row-2 .field-group {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-row-2 .field-group:nth-child(4) { /* Postal Code */\n  flex: 0 0 120px;\n  max-width: 120px;\n}\n\n/* For residential address (no P.O. Box) - adjust selectors */\n.residential-address-container .form-row-1 .field-group:nth-child(1) { /* Apt/Unit */\n  flex: 0 0 120px;\n  max-width: 120px;\n}\n\n.residential-address-container .form-row-1 .field-group:nth-child(2) { /* Street # */\n  flex: 0 0 100px;\n  max-width: 100px;\n}\n\n.residential-address-container .form-row-1 .field-group:nth-child(3) { /* Street Name */\n  flex: 1;\n  min-width: 0;\n}\n\n.residential-note {\n  margin: 0 0 8px 0;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 13px;\n  margin-top: 10px;\n  display: block;\n  padding: 10px 15px;\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 6px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-row {\n    flex-wrap: wrap;\n  }\n  \n  .form-row-1 .field-group,\n  .form-row-2 .field-group {\n    flex: 1 1 calc(50% - 4px);\n    min-width: 120px;\n  }\n  \n  .same-address-options {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .radio-option {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-row-1 .field-group,\n  .form-row-2 .field-group {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n  \n  .entry-form {\n    padding: 12px;\n  }\n  \n  .field-group input {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n  \n  .field-group label {\n    font-size: 12px;\n    line-height: 1.3;\n    min-height: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
